import { Customer } from "../models/Customer"
import { Product } from "../models/Product"
import { format } from "date-fns"
import { BACKEND_ROUTE, getRequest, PDF_TYPE } from "../request"
import { Category } from "../models/Category"
import { ISelectableOption } from "../components/interfaces/ISelectableOption"
import { Worksheet } from "../models/Worksheet"
import { WorksheetItem } from "../models/WorksheetItem"
import { Settings } from "../models/Settings"
import { Setting } from "../models/Setting"
import { TimeSpent } from "../models/TimeSpent"
import { ExternalWork } from "../models/ExternalWork"
import { Tool } from "../models/Tool"
import { ToolData } from "../models/ToolData"
import { ServiceData } from "../models/ServiceData"
import { FiltersObject } from "../models/Filter"
import { PaymentMethod } from "../models/PaymentMethod"
import { Currency } from "../models/Currency"
import { Vat } from "../models/Vat"
import { QuantityUnit } from "../models/QuantityUnit"
import { ProductCurrencyPrice } from "../models/ProductCurrencyPrice"
import { error } from "console"
import { store } from "../App"
import { showErrorMessages } from "../reducers/rootReducer"

export const trimLongString = (string: string, length: number) => 
    string !== null && string !== '' && string.length > length ? 
        string.substring(0, length - 3) + "..." : string

export const breakUpString = (string: string, breakAt: number) => {
        if(string !== null && string !== '' && string.length > breakAt) {
                var array = []
                var i, l
                for(i = 0, l = string.length; i < l; i += breakAt) {
                        array.push(string.substring(i, breakAt))
                }
                return array.join(' ')
        }
        else return string
}

export const isObjectUnavailable = (data: Worksheet | Customer | Product | Settings | Setting | TimeSpent | ExternalWork | Tool | ToolData | ServiceData | FiltersObject ) => 
        !data || data === null || data === undefined || Object.keys(data).length === 0

export const isArrayUnavailable = (data: Customer[] | Product[] | Worksheet[] | WorksheetItem[] | Setting[] | Tool[] | ToolData[] | ServiceData[] ) =>
        !data || data.length === 0 || data === null || data === undefined

export const getDateString = (date: Date | undefined) =>
        (date !== undefined && date !== null) ? new Date(date).toLocaleDateString("hu-HU").replaceAll(' ', '') : '-'
        
export const getNetValue = (item: WorksheetItem) => roundToTwoDecimals(item.UnitPrice * item.Quantity)

export const getGrossValue = (item: WorksheetItem) => roundToTwoDecimals(getNetValue(item) * (1 + item.Vat.Rate / 100))

export const roundToTwoDecimals = (num: number) => Math.round((num + Number.EPSILON) * 100) / 100

export const loadMasterData = async (route : BACKEND_ROUTE, setState : any, type : ISelectableOption) => {
        await getRequest(route, null).then(async function(res) { 
                if (res !== null || res[0] !== null) {
                        let vatList = res as typeof type[]
                        let dictionary : typeof type[] = Object.assign({}, ...vatList.map((x) => ({[x.Id]: x})))
                        setState(dictionary)
                } 
        }).catch((error) => console.error(error))
}
export const loadCategoryList = async (route : BACKEND_ROUTE, setState : any) => {
        await getRequest(route, null).then(async function(res) { 
                if (res !== null || res[0] !== null) {
                        let vatList = res as Category[]
                        let dictionary : Category[] = Object.assign({}, ...vatList.map((x) => (x.Level === 2 ? {[x.Id]: x} : null)))
                        setState(dictionary)
                } 
        }).catch((error) => console.error(error))
}

export const loadPaymentMethodList = async (setState: any) => {
        await getRequest(BACKEND_ROUTE.PAYMENTMETHOD, null).then(async function(res) { 
                if (res !== null || res[0] !== null) {
                        let list = res as PaymentMethod[]
                        setState(list)
                } 
        }).catch((error) => console.error(error))
}

export const loadVatList = async (setState: any) => {
        await getRequest(BACKEND_ROUTE.VAT, null).then(async function(res) { 
                if (res !== null || res[0] !== null) {
                        let list = res as Vat[]
                        setState(list)
                } 
        }).catch((error) => console.error(error))
}

export const loadCurrencyList = async (setState: any, isDictionary?: boolean) => {
        await getRequest(BACKEND_ROUTE.CURRENCY, null).then(async function(res) { 
                if (res !== null || res[0] !== null) {
                        let list = res as Currency[]
                        if(isDictionary) {
                                let dictionary : Currency[] = Object.assign({}, ...list.map((x) => ({[x.Id]: x})))
                                setState(dictionary)
                        }
                        else
                                setState(list)
                } 
        }).catch((error) => console.error(error))
}

export const loadQuantityUnitList = async (setState: any) => {
        await getRequest(BACKEND_ROUTE.QUANTITYUNIT, null).then(async function(res) { 
                if (res !== null || res[0] !== null) {
                        let list = res as QuantityUnit[]
                        setState(list)
                } 
                }).catch((error) =>{
                        console.error(error)
                })
}

export const loadProductCurrencyList = async (setState: any, productId: number, isDictionary?: boolean) => {
        await getRequest(BACKEND_ROUTE.CURRENCY_PRODUCT, null, '/' + productId).then(async function(res) { 
                if (res !== null || res[0] !== null) {
                        let list = res as ProductCurrencyPrice[]
                        if(isDictionary){
                                let dictionary : ProductCurrencyPrice[] = Object.assign({}, ...list.map((x) => ({[x.CurrencyId]: x})))
                                setState(dictionary)
                        } else
                                setState(list)
                } 
        }).catch((error) => console.error(error))
}

export const loadNextCode = async (setState: any, route: BACKEND_ROUTE) => {
        await getRequest(route, null).then(async function(res) { 
                if (res !== null || res[0] !== null)
                        setState(res)
        }).catch((error) => console.error(error))
}

export const getWorksheetTitles = async (setWorksheet: any) => 
        await getRequest(BACKEND_ROUTE.WORKSHEET_TITLES, null)
        .then((res) => setWorksheet(res))
        .catch((e) => console.error(e))


export const showLoadingScreen = async (show: boolean, setIsLoading: React.Dispatch<React.SetStateAction<boolean>>) => await setIsLoading(show)

export const downloadPDF = (pdf : string, type: PDF_TYPE, hint: string) => {
        const linkSource = `data:application/pdf;base64,${pdf}`
        const downloadLink = document.createElement("a")
        const fileName = `${type}_${hint}`
    
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
    }

export const base64toBlob = (data: string) => {
        const bytes = atob(data)
        let length = bytes.length
        let out = new Uint8Array(length)
    
        while (length--)
            out[length] = bytes.charCodeAt(length)
        
        return new Blob([out], { type: 'application/pdf' })
}

export function getBase64(file: any) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
}

export const base64toImage = (data: string) => {
        const bytes = atob(data)
        let length = bytes.length
        let out = new Uint8Array(length)
    
        while (length--) 
            out[length] = bytes.charCodeAt(length)
    
        return new Blob([out], { type: 'image/png' || "image/jpeg" })
}

export const mobileCheck = () => {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor)
        return check
}

export const desktopCheck = () => {
        let details = navigator.userAgent
        let regexp = /android|iphone|kindle|ipad/i
        let isMobileDevice = regexp.test(details)
        return !isMobileDevice
}

export function numberWithSeparator(x: number) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g,  ' ');
    }